"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var player_1 = require("../../stores/player");
var _kernel_store_types_1 = require("../../types");
var global_1 = require("../../selectors/global");
var toggleCaching_1 = __importDefault(require("../caching/toggleCaching"));
var checkRequiredPlayState_1 = __importDefault(require("./checkRequiredPlayState"));
var _kernel_container_1 = __importDefault(require("../../../container"));
function checkDisableControls() {
    var logger = _kernel_container_1.default
        .get("LOGGING")
        .getLogger("@kernel/checkDisableControls");
    var action = function (dispatch, getState) {
        var disableControls = (0, global_1.selectHasDisableControlsAdditionalFeature)(getState());
        if (disableControls) {
            logger.debug("Controls disabled, starting playback and turning on background caching...");
            dispatch((0, toggleCaching_1.default)(true));
            dispatch((0, player_1.setRequiredPlayState)(_kernel_store_types_1.EPlayState.PLAY));
            dispatch((0, checkRequiredPlayState_1.default)());
        }
    };
    action.type = checkDisableControls.type;
    return action;
}
checkDisableControls.type = "checkDisableControls";
exports.default = checkDisableControls;
//# sourceMappingURL=checkDisableControls.js.map